export function CTA() {
  return (
    <section className="py-24 bg-white">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="relative overflow-hidden rounded-3xl">
          {/* Gradient background */}
          <div className="absolute inset-0 bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500" />
          
          {/* Content */}
          <div className="relative px-8 py-16 sm:px-16 sm:py-20 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Raise the bar on every hire
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto mb-8">
              Start making hiring decisions you can trust. Jumpstone HR gives your team the signal and structure to decide with confidence.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="/signup" 
                className="w-full sm:w-auto btn bg-white text-surface-900 hover:bg-surface-100 text-base px-8 py-3.5 font-semibold"
              >
                Get Started
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="/#workflow" 
                className="w-full sm:w-auto btn bg-white/20 text-white hover:bg-white/30 border border-white/30 text-base px-8 py-3.5"
              >
                See How It Works
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
